import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import { OrderDetail } from '../types';
import { formatCurrency } from '../helpers';

interface PriceInfoSectionProps {
  order: OrderDetail;
}

export const PriceInfoSection: React.FC<PriceInfoSectionProps> = ({
  order,
}) => {
  const translations = useSelector(selectTranslations);
  const firstItem = order.orderItems[0];
  if (!firstItem) return null;

  const { combo } = firstItem;
  const quantity = combo.quantity; // Total adult + child passengers
  const pricePerPax = quantity > 0 ? combo.salePrice / quantity : 0;

  return (
    <Content>
      <SectionTitle>
        {combo.comboName || combo.name || 'Combo Holiday'} ({quantity} {translations?.['b2b.txt.personUnit'] || 'người'})
      </SectionTitle>
      <Row>
        <Label>{translations?.['b2b.txt.priceByPassengerType'] || 'Tổng giá vé theo loại hành khách'}</Label>
        <Value>{formatCurrency(pricePerPax)}</Value>
      </Row>
      <Divider />
      <TotalRow>
        <TotalLabel>{translations?.['b2b.txt.totalAmount'] || 'Tổng tiền'}</TotalLabel>
        <TotalValue>{formatCurrency(order.totalPayment)}</TotalValue>
      </TotalRow>
    </Content>
  );
};

const Content = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  overflow: hidden;
`;

const SectionTitle = styled.div`
  background: #f2f2f2;
  padding: 8px 12px;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 12px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  padding: 0 12px;
`;

const Label = styled.div`
  font-weight: 600;
`;

const Value = styled.div`
  font-weight: 600;
`;

const Divider = styled.div`
  height: 1px;
  background: #e5e5e5;
  margin: 12px 0;
`;

const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  padding-bottom: 12px;
`;

const TotalLabel = styled.div`
  font-size: 16px;
  font-weight: 600;
`;

const TotalValue = styled.div`
  font-size: 16px;
  font-weight: 600;
`;
